export default function loadData(elementId: string) {
  const data = {};
  if (document) {
    const element: HTMLElement = document.getElementById(elementId);
    Object.keys(element.dataset).forEach(function(field: string){
      const value: string = element.dataset[field];
      const prop_name: string = field;
      try {
        data[prop_name] = JSON.parse(value);
      } catch(e) {
        data[prop_name] = value;
      }
    })
  }
  return data;
}
